import { TPAComponentProps } from '../../../types';

export interface TabsNavButtonProps extends TPAComponentProps {
  onClick(): void;
  children?: React.ReactNode;
}
